import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {ProductSizeProfileList} from '../interface/product-size-profile-list';
import {SizeProfileOption} from '../interface/size-profile-option';
import {MadeToOrderFabric} from '../interface/made-to-order-fabric';
import {MadeToOrderProfile} from '../interface/made-to-order-profile';

@Injectable({
	providedIn: 'root'
})
export class QuantityCalculationService {

	constructor() {
		// console.log("service called");
	}

	public calculatedQuantity = new Subject<any>();
	public availableSizeList: ProductSizeProfileList[] = [];
	public sizeList: SizeProfileOption[] = [];

	public madeToOrderProfile: MadeToOrderProfile | undefined = {} as MadeToOrderProfile;
	public madeToOrderProfileConsumedFabric: number = 0; //made to profile consumed fabric

	public selectedSizeQuantity: number = 0;
	public selectedSizeCunsumedFabric: number = 0; // size consumed  fabric



	public productMadeFabricQuantity: number = 0; //made to order fabric quantity

	public productMadeFabric: MadeToOrderFabric = {} as MadeToOrderFabric; //made to order fabric





	public madeToOrderConsumeFabric = 0;

	public selectedAvailableSizeQuantity = 0;
	public selectedFabricQuantity = 0;

	public selectedConsumeFabric = 0;
	public selctedConsumeSize = 0;
	public MTOselected = true;
	public copySelectedSizeQuantityValidOnly = 0;
	public defaultProductQTY:number = 0;

	public onLoadQuantityCalculation(): void {

		// console.log(this.availableSizeList);
		// debugger
		// console.log(this.sizeList);

		let calculated = 0;
		if (this.MTOselected) {
			if (!this.sizeList) {
				calculated = (this.productMadeFabric?this.productMadeFabric.totalQuantity:1) / (this.madeToOrderProfile ?this.madeToOrderProfile.consumedFabric : 1);
			} else {
				calculated = this.selectedAvailableSizeQuantity;
			}
			let round = Math.floor(calculated)
			this.calculatedQuantity.next(round);
		}

	}



	public updateQuantity(): void {
		// debugger
		let round = 0;
		if (!this.MTOselected) this.selectedAvailableSizeQuantity = 0;
		// if(this.MTOselected){
		if (this.selectedAvailableSizeQuantity != 0) {
			round = Math.floor(this.selectedAvailableSizeQuantity)
			this.calculatedQuantity.next(round);
		}
		else {
			let calcFabQTYandMTOConsumeFabric;

			if (!this.MTOselected) {
				calcFabQTYandMTOConsumeFabric = this.selectedFabricQuantity / this.selctedConsumeSize;
			} else {
				calcFabQTYandMTOConsumeFabric = this.selectedFabricQuantity / this.madeToOrderConsumeFabric;
			}

			round = Math.floor(calcFabQTYandMTOConsumeFabric)
			this.calculatedQuantity.next(round);
		}

	}


	public UpdateQuantityFabric(isMto: boolean) {
		// debugger
		if (isMto) {
			if (this.selectedAvailableSizeQuantity != 0) {
				let round = Math.floor(this.selectedAvailableSizeQuantity)
				this.calculatedQuantity.next(round);
			}
			else {
				let cal = this.selectedSizeQuantity / this.madeToOrderConsumeFabric;
				let round = Math.floor(cal)
				this.calculatedQuantity.next(round);
			}
			// this.updateQuantity()
		}
		else {
			let calcFabQTYandConsumeSize = this.selectedFabricQuantity / this.selctedConsumeSize;
			calcFabQTYandConsumeSize = isFinite(1000 / calcFabQTYandConsumeSize)?0:calcFabQTYandConsumeSize;
			let round = Math.floor(calcFabQTYandConsumeSize)
			this.calculatedQuantity.next(round);
		}
	}

}
